import { Injectable, Inject, Optional } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { BASE_PATH } from '@smatchy/sdk';

export interface PayoutExportFilters {
  search?: string;
  status?: string;
  startDate?: string;
  endDate?: string;
  sortBy?: string;
  sortOrder?: 'asc' | 'desc';
}

/**
 * Downloads the payout-requests CSV the API builds at
 * GET /admin/payouts/export/csv.
 *
 * The page already lists payouts through the generated SDK; the export is a
 * raw HttpClient GET instead, because the SDK has no blob-returning operation
 * and a plain navigation would not carry the bearer token the TokenInterceptor
 * adds to HttpClient calls. page and limit are not sent: the file is the whole
 * filtered set (capped server-side), not the page on screen.
 */
@Injectable({ providedIn: 'root' })
export class PayoutExportApiService {
  private basePath: string;

  constructor(private http: HttpClient, @Optional() @Inject(BASE_PATH) basePath: string) {
    this.basePath = basePath || 'http://localhost:3000';
  }

  exportPayoutRequestsCsv(filters: PayoutExportFilters = {}): Observable<Blob> {
    let params = new HttpParams();
    if (filters.search) params = params.set('search', filters.search);
    if (filters.status) params = params.set('status', filters.status);
    if (filters.startDate) params = params.set('startDate', filters.startDate);
    if (filters.endDate) params = params.set('endDate', filters.endDate);
    if (filters.sortBy) params = params.set('sortBy', filters.sortBy);
    if (filters.sortOrder) params = params.set('sortOrder', filters.sortOrder);
    return this.http.get(`${this.basePath}/admin/payouts/export/csv`, {
      params,
      responseType: 'blob',
    });
  }
}
